import React, { useState } from "react";
import { Link } from "react-router-dom";
import { forgotPassword } from "../services/authApi";

const ForgotPasswordLayer = () => {
  const [email, setEmail] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleEmailChange = (event) => {
    setEmail(event.target.value);

    if (statusMessage) {
      setStatusMessage("");
    }

    if (error) {
      setError("");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isSubmitting) {
      return;
    }

    setStatusMessage("");
    setError("");
    setIsSubmitting(true);

    try {
      const response = await forgotPassword(email.trim());

      setStatusMessage(
        response?.message ||
          "If an account exists for that email, password reset instructions will be sent."
      );
    } catch (requestError) {
      setError(
        requestError.message ||
          "We could not process your request. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="simplif-auth-page">
      <header className="simplif-auth-header">
        <Link to="/sign-in" className="simplif-auth-logo">
          <img
            src="/assets/images/simplif/simplif-logo.png"
            alt="Simplif"
          />
        </Link>

        <div className="simplif-auth-header-actions">
          <Link to="/sign-in" className="simplif-auth-login-link">
            Login
          </Link>

          <Link to="/sign-up" className="simplif-auth-signup-button">
            SIGN UP
          </Link>
        </div>
      </header>

      <main className="simplif-auth-main">
        <div className="simplif-auth-card">
          <section className="simplif-auth-form-panel">
            <div className="simplif-auth-form-content">
              <h1>Reset Your Password</h1>

              <p className="simplif-auth-subtitle">
                Enter the email address associated with your account,
                and we'll send you a link to reset your password.
              </p>

              <form onSubmit={handleSubmit}>
                <div className="simplif-auth-field">
                  <label htmlFor="reset-email">
                    Email
                  </label>

                  <input
                    id="reset-email"
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={handleEmailChange}
                    autoComplete="email"
                    disabled={isSubmitting}
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="simplif-auth-primary-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting
                    ? "Sending..."
                    : "Send Link"}
                </button>

                {statusMessage ? (
                  <p
                    className="simplif-auth-status-message"
                    role="status"
                  >
                    {statusMessage}
                  </p>
                ) : null}

                {error ? (
                  <p
                    className="simplif-auth-status-message"
                    role="alert"
                  >
                    {error}
                  </p>
                ) : null}
              </form>
            </div>
          </section>

          <section className="simplif-auth-side-panel">
            <div className="simplif-auth-pattern simplif-auth-pattern-top" />

            <div className="simplif-auth-side-content">
              <h2>Return to Sign in</h2>

              <p>
                Remembered your password? Return to sign in.
              </p>

              <Link
                to="/sign-in"
                className="simplif-auth-secondary-button"
              >
                Sign in
              </Link>
            </div>

            <div className="simplif-auth-pattern simplif-auth-pattern-bottom" />

            <div className="simplif-auth-support">
              <span className="simplif-auth-support-icon">?</span>
              <strong>Need Help?</strong> Support@simplif.com
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default ForgotPasswordLayer;
